package com.hyperether.goodjob.scenes.scheduler

enum class PeriodType {
    DAY,
    WEEK,
    MONTH
}